export default __webpack_public_path__ + "static/media/nodejs_logo.33f66c06.png";